import React, { Component } from 'react'
import LoopSliderBoxNew from '../../ReusableComponents/NewSlider/LoopSliderBoxNew'
import InputNumber from '../../logic/panels/helpers/InputNumber'
import PanelHighlightContext, {
    isKeyHighlighted,
} from '../PanelHighlightContext'

import '../../logic/panels/loop.css'

class LoopPanel extends Component {
    static contextType = PanelHighlightContext

    constructor(props) {
        super(props)
        this.state = {}
    }
    onChange = (value) => {
        if (value < 1) value = 1
        else if (value > 255) value = 255
        this.props.onChange({ times: value })
    }
    render() {
        const { state } = this.props
        const _hlInfo = this.context
        const _hlTimes = isKeyHighlighted(_hlInfo, 'times') ? 'highlight-panel-slider' : ''

        return (
            /* We add display: flex and align-items: center to the wrapper.
               We also set height: 100% to ensure the wrapper fills the panel space.
            */
            <div className={_hlTimes} style={{ display: 'flex', alignItems: 'center', height: '100%', width: '100%' }}>
                <LoopSliderBoxNew
                    /* Keep your original margin if needed, but flex centering usually replaces the need for it */
                    style={{ marginTop: '0%' }} 
                    min={0}
                    max={255}
                    value={state.times || 1}
                    onChange={(e) => {
                        this.props.onChange({ times: e.target.value })
                    }}
                />
            </div>
        )
    }
}

export default LoopPanel
